const INFO = {
	main: {
		title: "Piyush Mittal",
		name: "Piyush Mittal",
		email: "mittalpiyush2019@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://x.com/stalledlogic",
		github: "https://github.com/mittalpiyush06",
		linkedin: "https://www.linkedin.com/in/pmittal06/",
		codeforces: "https://codeforces.com/profile/present_sir",
	},

	homepage: {
		title: "Engineering @ Intuit",
		description: "Crafting impactful software solutions is my passion. My experience at Intuit honed my skills across the full software development lifecycle, including UI optimization, API integration, and streamlining processes. My expertise in Java and React.js fuels my drive for intuitive and user-friendly software. Beyond technical skills, I'm a strong problem-solver with leadership qualities honed through event coordination."
	},

	about: {
		title: "I'm Piyush. Passionate About Tackling Tough Challenges.",
		description:
			"Crafting impactful software solutions is my passion. My experience at Intuit honed my skills across the full software development lifecycle, including UI optimization, API integration, and streamlining processes. I've successfully redesigned UIs, optimized API calls, and significantly reduced onboarding times. Prior experience focused on user experience improvements, implementing user-defined features and a spreadsheet-sync system. My expertise in React.js fuels my drive for intuitive and user-friendly software. Beyond technical skills, I'm a strong problem-solver with leadership qualities honed through event coordination. I'm eager to contribute my diverse experience and passion to innovative projects."
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Route Planner",
			description:
				"Co-developed a real-time navigation website to enhance multi-stop commuting efficiency, using Google Maps APIs and the Traveling Salesman Algorithm to optimize routes.",
			logo: "./route_planner.jpeg",
			linkText: "View Project",
			link: "https://github.com/N-a-m-a-n/Traveling-Salesman",
		},

		{
			title: "NFT Fractionalizer",
			description:
				"Fractionalized ERC-1155 tokens into on-chain assets, making NFTs more accessible for buyers with limited funds, while incentivizing users to boost liquidity pools by 60%.",
			logo: "./nft.png",
			linkText: "View Project",
			link: "http://foofanft.surge.sh/",
		},

		{
			title: "BlockCast",
			description:
				"Co-developed a Blockchain-based chat room website with two colleagues, enhancing message security and ensuring 100% transparency and censorship resistance by storing all data on-chain.",
			logo: "./blockast.png",
			linkText: "View Project",
			link: "https://github.com/amulya00/blockcast",
		},
	],
};

export default INFO;
